import React, { useEffect, useMemo, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {

  return (
    <PageLayout
      banner='/image/contacts-banner.png'
    >
      <>
        {getHead(navDetail)}
        <div dangerouslySetInnerHTML={{ __html: navDetail?.content }} />
      </>
    </PageLayout>

  );
};


